import { render, staticRenderFns } from "./rmHefc.vue?vue&type=template&id=16267896"
import script from "./rmHefc.vue?vue&type=script&lang=js"
export * from "./rmHefc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports